export const primaryFont = 'Brandon Grotesque, sans-serif';
export const secondaryFont =
  'Adobe Garamond Pro, adobe-garamond-pro,Adobe Garamond, Garamond,serif;';
export const AngeliquemadouceColombeFont = 'AngeliquemadouceColombe';
export const monoFont = 'monospace';
export const helvetica = '"Helvetica Neue", Helvetica, sans-serif';
